// Deep merge bản ghi đè branding vào locale gốc, để không phải sửa 15 file
// upstream. Spread không dùng được: nó merge nông, ghi đè `LOGIN.TITLE` sẽ
// thay cả cụm `LOGIN` và nuốt mọi key anh em.
export const gopSau = (goc, ghiDe) => {
  const ra = { ...goc };
  Object.entries(ghiDe).forEach(([khoa, giatri]) => {
    const cu = ra[khoa];
    const caHaiLaObject =
      cu && giatri && typeof cu === 'object' && typeof giatri === 'object';
    ra[khoa] = caHaiLaObject ? gopSau(cu, giatri) : giatri;
  });
  return ra;
};

export default gopSau;
